import {
  ButtonHierarchy,
  ButtonSize,
  MainButton,
  Typography,
  TypographySize,
  TypographyWeight,
} from "@beydesign/storybook"
import { Box } from "@mui/material"
import { Microphone, VideoCamera } from "@phosphor-icons/react"
import React, { PropsWithChildren } from "react"

interface VideoAndMicAccessModalProps {
  open: boolean
  onRequestAccess: () => void
  isLoading?: boolean
}

const iconProps = { size: 30, color: "var(--colors-light-text-text-white)" }

const IconContainer: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <Box
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
      borderRadius={"var(--spacing-tokens-size-in-px-radius-radius-lg)"}
      padding={"var(--spacing-tokens-size-in-px-spacing-spacing-lg)"}
      gap={"var(--spacing-tokens-size-in-px-spacing-spacing-md)"}
      bgcolor={"var(--primitives-desktop-primary-white-20)"}
    >
      {children}
    </Box>
  )
}

export const VideoAndMicAccessModal: React.FC<VideoAndMicAccessModalProps> = ({
  open,
  onRequestAccess,
  isLoading = false,
}) => {
  if (!open) return null

  return (
    <Box
      position="absolute"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      width="100%"
      height="40%"
      bottom={0}
      right={0}
      left={0}
      sx={{
        borderRadius: "1rem",
      }}
    >
      <Box
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"center"}
        alignItems={"center"}
        gap={"var(--spacing-tokens-size-in-px-spacing-spacing-3xl)"}
        height={"100%"}
        width={"100%"}
      >
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
          gap={"var(--spacing-tokens-size-in-px-spacing-spacing-3xl)"}
        >
          <IconContainer children={<Microphone {...iconProps} />} />
          <IconContainer children={<VideoCamera {...iconProps} />} />
        </Box>
        <Typography
          text="Please allow Camera and Microphone access to proceed."
          size={TypographySize.HeadingM}
          weight={TypographyWeight.Medium}
          color="var(--colors-light-text-text-white)"
        />
        <MainButton
          onClick={onRequestAccess}
          text={isLoading ? "Requesting Access..." : "Allow Access"}
          size={ButtonSize.md}
          hierarchy={ButtonHierarchy.PrimaryLemon}
          loading={isLoading}
          disabled={isLoading}
        />
      </Box>
    </Box>
  )
}
